import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import setGlobalModules from './globalModules'
import setGlobalComponents from './globalComponents'

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
    beforeCreate() {
        Vue.config.productionTip = false

        setGlobalModules()
        setGlobalComponents()
        i18n.locale = 'pl'
        this.$Network.setHeaders(this)
    }
}).$mount('#app')
